export default function ReviewOrderButton({ disabled, onClick }) {
  return (
    <button className="btn btn-primary btn-lg fw-bold" type="button" disabled={disabled} onClick={onClick}>
      Review order
    </button>
  );
}
